import { ShareOutlineIcon } from '@ikyucom/design-system-icons-react'
import { useCallback } from 'react'
import { useEnv } from '~/env'
import { getFragmentData, graphql } from '~/lib/graphql'
import type { FragmentType } from '~/lib/graphql'
import { useIsPC } from '~/lib/ua'
import { IconButton } from '~/ui/IconButton'
import { PcShareButton } from './PcShareButton'
import { useWebShareSupported } from './useWebShareSupported'

const ShareRestaurantButtonFragment = graphql(`
  fragment ShareRestaurantButton on Restaurant {
    restaurantId
    name
    fullAddress
  }
`)

type Props = {
  restaurant: FragmentType<typeof ShareRestaurantButtonFragment>
}

export function ShareRestaurantButton(props: Props) {
  const isPc = useIsPC()
  const Button = isPc ? PcShareRestaurantButton : SdShareRestaurantButton

  return <Button {...props} />
}

function SdShareRestaurantButton({ restaurant: data }: Props) {
  const restaurant = getFragmentData(ShareRestaurantButtonFragment, data)
  const webShareSupported = useWebShareSupported()

  const onClick = useCallback(() => {
    navigator
      .share({
        url: `/${restaurant.restaurantId}`,
      })
      .catch() // ignore share error on android LINE embed
  }, [restaurant.restaurantId])

  return webShareSupported ? (
    <IconButton
      Icon={ShareOutlineIcon}
      onClick={onClick}
      theme="filled"
      size="sm"
      aria-label="このレストラン情報を共有する"
    />
  ) : null
}

function PcShareRestaurantButton({ restaurant: data }: Props) {
  const restaurant = getFragmentData(ShareRestaurantButtonFragment, data)
  const { RESTAURANT_IKYU_ORIGIN } = useEnv()

  return (
    <PcShareButton
      type="レストラン"
      title={restaurant.name}
      description={restaurant.fullAddress}
      url={`${RESTAURANT_IKYU_ORIGIN}/${restaurant.restaurantId}`}
    />
  )
}
